import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InvoicesState } from "./types";
import { cancelInvoice, fetchInvoices } from "./invoices-thunk";
import { ErrorType } from "@/shared/types";
import { InvoiceStatuses } from "@/shared/api/invoices";

const initialState: InvoicesState = {
    invoices: [],
    isLoading: false,
    isFirstLoad: true,
    error: null,
    page: 1,
    limit: 50,
    totalPages: 0
}

const invoicesSlice = createSlice({
    name: 'invoices',
    initialState,
    reducers: {
        setPage: (state, action: PayloadAction<number>) => {
            state.page = action.payload
        }
    },
    extraReducers(builder) {
        builder
        .addCase(fetchInvoices.pending, (state) => {
            state.isLoading = true
        })
        .addCase(fetchInvoices.fulfilled, (state, action) => {
            state.error = null
            state.invoices = action.payload.items
            state.totalPages = action.payload.totalPages
            state.isLoading = false
        })
        .addCase(fetchInvoices.rejected, (state, action) => {
            state.error = action.payload as ErrorType ?? null
            state.isLoading = false
        })
        .addCase(cancelInvoice.fulfilled, (state, action) => {
            state.invoices = state.invoices.map((invoice) => invoice.id === action.meta.arg ? {...invoice, status: InvoiceStatuses.canceled} : invoice)
        })
    },
})

export default invoicesSlice.reducer
export const { setPage } = invoicesSlice.actions